module.exports = __webpack_public_path__ + "static/media/circles-ballet.0ff220ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/circles-ballet.png
// module id = 1049
// module chunks = 0